import React from 'react';
import { createPortal } from 'react-dom';
import { SETTINGS } from '../../constants';
// logic

const PortalContent = ({ children }) => {
  const portalContainer = document.getElementById(SETTINGS.PORTAL_ID);
  return (
    <>
      {document &&
        portalContainer &&
        createPortal(<>{children}</>, portalContainer)}
    </>
  );
};

export default PortalContent;
